/* Renders the task home */

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { NoVisitSubPage } from './TaskHomeNoVisit';
import { BetweenVisitSubPage, computeGreetingInstForBetweenVisit } from './TaskHomeBetween';
import PausedHomePage from './PausedHomePage';
import { withRouter, useHistory } from 'react-router-dom';
import {
    VisitState,
    taskCompleted,
    checkLabworkStatus,
    LabworkStatus,
    checkForLabWorkBusinessStatus,
    TASK_BUSINESS_STATUS_MANUAL_LAB,
    isTaskPresent,
    checkImagingStatus,
} from '../../utils/VisitTaskHandler';
import * as TaskNames from '../home/TaskNames';
import MainLayout from '../utilities/layouts/MainLayout';
import { Typography, Box, Grid, Paper, useTheme } from '@material-ui/core';
import { WaitingReviewTaskBoard } from './WaitingForReview';
import { CardItem, CardList } from '../utilities/commonUtilities/CardItem';
import RecordBadge from '../../resources/images/record-badge.svg';
import { ReactComponent as DoctorNoteBadge } from '../../resources/images/note-badge.svg';
import BloodBadge from '../../resources/images/blood-badge.svg';
import ImageBadge from '../../resources/images/imaging-badge.svg';
import ClinicianIcon from '../../resources/images/clinician.svg';
import ClinicianDektopIcon from '../../resources/images/clinician-desktop.svg';
import DoneBadge from '../../resources/images/done-badge.svg';
import { daysLeftFromToday, formatDateMMMMDYYYY, isoMoment } from '../utilities/commonUtilities/dateTools';
import moment from 'moment';
import { PATH_LAB_REQUISITION, PATH_WELLNESS_SURVEY_HOME, PATH_DOCTOR_NOTE, PATH_FREE_TEXT_SURVEY_HOME, PATH_IMAGING } from '../../containers/RoutePaths';
import { RequiresLogin } from '../utilities/commonUtilities/RequiresLogin';
import { useCurrentVisit, CurrentVisitUser } from '../../userDataProviders/CurrentVisitProvider';
import NextUp from '../utilities/commonUtilities/NextUpComponent';
import AlertModalYesNo from '../utilities/AlertModal/AlertModalYesNo';
import {
    closeCurrentVisit,
    labWorkTaskInProgressMarking,
    retrieveCurrentVisit,
    sendClientAnalytics,
    retrieveAllVisits,
    updateUnreadMessages,
    setMaximumUnreadMessageCount,
} from '../../actions';
import { connect } from 'react-redux';
import IsLoadingPage from '../IsLoadingPage';
import LoadingErrorPage from '../LoadingErrorPage';
import { LoadingStatus, LoadingResult } from '../../utils/LoadingUtils';
import { markLabWorkTaskAsInProgress } from '../../apis/currentVisit';
import DataSubmissionHandler from '../DataSubmissionHandler';
import * as actions from '../../actions/actionTypes';
import { call, takeLatest, put } from 'redux-saga/effects';
import { AuditEventAction, createClientAnalytics } from '../../utils/ClientAnalytics';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import { TaskHomeStyle as useStyles, getDoneBackgroundColor } from '../../styles/TaskHomeStyle';
import styled from 'styled-components';
import { styleBreakDesktop } from '../utilities/layouts/Globals';
import { ReactComponent as CallDoctor } from '../../resources/images/call-doctor.svg';
import YourJourneyComponent from '../calendar/YourJourneyComponent';
import { styleBreakMobile } from '../utilities/layouts/Globals';
import TutorialWelcomePage from '../tutorials/TutorialWelcomePage';

const isWatchman = process.env.REACT_APP_THEME_ENV === 'watchman';

export const VisitAssessments = {
    VIDEO_REQUIRED: 'VIDEO_REQUIRED',
    PHONE_REQUIRED: 'PHONE_REQUIRED',
    IN_PERSON: 'IN_PERSON',
    NO_CONCERNS: 'NO_CONCERNS',
    IN_CLINIC_REQUIRED: 'IN_CLINIC_REQUIRED',
    OFF_PROTOCOL: 'OFF_PROTOCOL',
};

export const AccountStates = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
};

export function image(src, alt, width, height) {
    const Img = styled.img`
        width: ${width ? width : '40px'};
        height: ${height ? height : '40px'};
    `;

    return () => {
        return <Img src={src} alt={alt} />;
    };
}

const TaskHomeContent = ({
    accountState,
    isLoadingVisit,
    visitLoadingResult,
    allVisits,
    allVisitsLoadingResult,
    isLoadingAllVisits,
    fetchAllVisits,
    updateUnreadMessageCount,
    setMaxUnreadMessageCount,
    patientDiagnosisDate,
}) => {
    const currentVisit = useCurrentVisit();

    useEffect(() => {
        if (!allVisits) {
            fetchAllVisits();
        }
    }, [fetchAllVisits, allVisits]);

    if (isLoadingVisit || isLoadingAllVisits) {
        return <IsLoadingPage loginNotRequired={true} />;
    } else {
        if (visitLoadingResult === LoadingResult.FAILED || allVisitsLoadingResult === LoadingResult.FAILED) {
            return <LoadingErrorPage loginNotRequired={true} />;
        } else {
            const visitState = currentVisit && currentVisit.visit && currentVisit.visit.visitState;
            // NEDVC-1132: If the visit has been reviewed by a doctor, allow the patient to review the note before showing the PAUSED screen.
            if (accountState === AccountStates.PAUSED && visitState !== VisitState.REVIEWED) {
                return <PausedHomePage />;
            } else {
                const taskDueDate = currentVisit.visit && currentVisit.visit.taskDueDate;
                const allTasksCompletedDate = currentVisit.visit && currentVisit.visit.allTasksCompletedDate;
                const targetClinicianReviewDueDate = currentVisit.visit && currentVisit.visit.clinicianReviewDueDate;

                const wellnessSurveyTaskDone = taskCompleted(currentVisit.visit, TaskNames.WELLNESS_SURVEY);
                const freeTextSurveyTaskDone = taskCompleted(currentVisit.visit, TaskNames.FREE_TEXT_SURVEY);
                const imagingTaskDone = taskCompleted(currentVisit.visit, TaskNames.IMAGING);
                const labWorkStatus = checkLabworkStatus(currentVisit.visit);
                const imagingStatus = checkImagingStatus(currentVisit.visit);

                const showNoVisit = !visitState;
                const showBetweenVisit = visitState === VisitState.NEW;
                const showViewDoctorNote = visitState === VisitState.REVIEWED;
                const isLabWorkTaskPresent = isTaskPresent(currentVisit.visit, TaskNames.LAB_WORK);
                const isWellnessSurveyTaskPresent = isTaskPresent(currentVisit.visit, TaskNames.WELLNESS_SURVEY);
                const isFreeTextSurveyTaskPresent = isTaskPresent(currentVisit.visit, TaskNames.FREE_TEXT_SURVEY);
                const isImagingTaskPresent = isTaskPresent(currentVisit.visit, TaskNames.IMAGING);

                let greetingText = '';
                let instructionText = '';
                let SubPageContent = null;
                let SubPageHeader = null;

                if (showViewDoctorNote) {
                    greetingText = 'Welcome Back';
                    instructionText = "Your doctor's response is now available. Please view the note for your next steps.";
                    const currentVisitAssessment = currentVisit?.visit?.assessment?.visitAssessmentResult ?? '';
                    SubPageContent = () => (
                        <>
                            <ViewDoctorNote />
                            <NextUpCardSection currentVisitAssessment={currentVisitAssessment} />
                            <YourJourneyComponent visits={allVisits} patientDiagnosisDate={patientDiagnosisDate} />
                        </>
                    );
                    SubPageHeader = () => <SubPageHeading greetingText={greetingText} instructionText={instructionText} />;
                } else if (showNoVisit) {
                    SubPageContent = () => <NoVisitSubPage />;
                    SubPageHeader = null;
                } else if (showBetweenVisit) {
                    // visits are sorted by taskOpenDate ascending order
                    // the FIRST NEW visit should be the next followup that shows up.
                    const nextVisit = allVisits.find(visit => visit?.visitState === 'NEW');
                    const greetingsInstObj = computeGreetingInstForBetweenVisit(nextVisit?.taskOpenDate);
                    instructionText = greetingsInstObj.instructionText;
                    greetingText = greetingsInstObj.greetingText;

                    SubPageHeader = () => <SubPageHeading greetingText={greetingText} instructionText={instructionText} />;
                    SubPageContent = () => (
                        <BetweenVisitSubPage taskOpenDate={nextVisit?.taskOpenDate} allVisits={allVisits} patientDiagnosisDate={patientDiagnosisDate} />
                    );
                } else if (
                    (!isWellnessSurveyTaskPresent || wellnessSurveyTaskDone) &&
                    (!isFreeTextSurveyTaskPresent || freeTextSurveyTaskDone) &&
                    (!isLabWorkTaskPresent || labWorkStatus === LabworkStatus.COMPLETED) &&
                    (!isImagingTaskPresent || imagingTaskDone)
                ) {
                    greetingText = 'Great job,';
                    instructionText = "Your tasks are complete! Please wait for your doctor's response.";
                    const isPendingClinicianManualLabsRetrieval = visitState === VisitState.PENDING_CLINICIAN_MANUAL_LABS_RETRIEVAL;

                    SubPageHeader = () => <SubPageHeading greetingText={greetingText} instructionText={instructionText} />;
                    const YourJourneyCard = <YourJourneyComponent visits={allVisits} patientDiagnosisDate={patientDiagnosisDate} />;
                    SubPageContent = () => (
                        <CompleteTaskBoard
                            submittedDate={allTasksCompletedDate}
                            expectedResponseDate={targetClinicianReviewDueDate}
                            isPendingClinicianManualLabsRetrieval={isPendingClinicianManualLabsRetrieval}
                            YourJourneyCard={YourJourneyCard}
                            hasViewableLabResults={isLabWorkTaskPresent || labWorkStatus === LabworkStatus.COMPLETED}
                        />
                    );
                } else {
                    if ([freeTextSurveyTaskDone, wellnessSurveyTaskDone, labWorkStatus === LabworkStatus.COMPLETED, imagingTaskDone].some(a => a === true)) {
                        greetingText = 'Almost done all of your tasks!';
                        instructionText = 'Once completed, your tasks will be sent to your doctor.';
                    } else {
                        greetingText = 'Welcome back,';
                        instructionText = 'Complete your tasks to let your doctor know how you are doing.';
                    }

                    const isLabworkManual = checkForLabWorkBusinessStatus(currentVisit.visit) === TASK_BUSINESS_STATUS_MANUAL_LAB;

                    SubPageHeader = () => <SubPageHeading greetingText={greetingText} instructionText={instructionText} />;
                    SubPageContent = () => (
                        <>
                            <IncompleteTaskBoard
                                taskDueDate={taskDueDate}
                                labWorkStatus={labWorkStatus}
                                imagingStatus={imagingStatus}
                                wellnessSurveyTaskDone={wellnessSurveyTaskDone}
                                isLabworkManual={isLabworkManual}
                                isLabWorkTaskPresent={isLabWorkTaskPresent}
                                isWellnessSurveyTaskPresent={isWellnessSurveyTaskPresent}
                                isFreeTextSurveyTaskPresent={isFreeTextSurveyTaskPresent}
                                isImagingTaskPresent={isImagingTaskPresent}
                                freeTextSurveyTaskDone={freeTextSurveyTaskDone}
                                imagingTaskDone={imagingTaskDone}
                                allVisits={allVisits}
                                patientDiagnosisDate={patientDiagnosisDate}
                            />
                        </>
                    );
                }

                return (
                    <MainLayout SubPageHeader={SubPageHeader}>
                        <SubPageContent />
                    </MainLayout>
                );
            }
        }
    }
};

/**
 * A page heading hat includes the greeting text and instruction text.
 * Usage:
 *
 * <SubPage greetingText='...' instructionText='...'>
 */
export const SubPageHeading = ({ greetingText, instructionText, stylesOverride }) => {
    const classes = useStyles(stylesOverride)();
    const bigScreen = useMediaQuery('(min-width:516px)');
    return (
        <Box component="div" className={classes.subsection}>
            <Box data-cy="label_instruction_box" component="div" className={classes.instructionBox}>
                <Typography align="center" variant="h3" className={classes.greetingTextTypography}>
                    {greetingText}
                </Typography>
                <Typography align="center">{instructionText}</Typography>
            </Box>
            <Box
                component="div"
                className={clsx(classes.subPageBox, {
                    [classes.subPageBoxBigScreen]: bigScreen,
                })}
            ></Box>
        </Box>
    );
};

const IncompleteTaskBoard = ({
    taskDueDate,
    labWorkStatus,
    imagingStatus,
    wellnessSurveyTaskDone,
    isLabworkManual,
    isLabWorkTaskPresent,
    isWellnessSurveyTaskPresent,
    isFreeTextSurveyTaskPresent,
    isImagingTaskPresent,
    freeTextSurveyTaskDone,
    allVisits,
    imagingTaskDone,
    patientDiagnosisDate,
}) => {
    const styling = useStyles({})();
    const theme = useTheme();
    const history = useHistory();
    const [submitting, setSubmitting] = useState(false);
    const bigMobileScreen = useMediaQuery('(min-width:618px) and (max-width:830px)');

    const nextUpCardTitle = "Doctor's Review";
    const nextUpCardText = 'Your results will be sent to your doctor for review once they are complete.';
    const DesktopScreen = useMediaQuery(theme => styleBreakDesktop(theme));
    const nextUpCardImage = DesktopScreen
        ? image(ClinicianDektopIcon, 'clinician', 'auto', '120px')
        : image(ClinicianIcon, 'clinician', 'auto', `${bigMobileScreen ? 116 : 140}px`);
    const labWorkInProgressSubmissionFailureTitle = 'Failed to Update Lab Work';
    const labWorkInProgressSubmissionFailureBody = 'Your computer might be offline or the server may be experiencing problems. Please try again.';
    const taskNotOverdue = moment()
        .startOf('day')
        .isBefore(isoMoment(taskDueDate).startOf('day'), 'day');

    const cardClickHandler = urlPath => {
        history.push(urlPath);
    };

    const labWorkTaskToIncompletesSubmissionSuccess = () => {
        history.push(PATH_LAB_REQUISITION);
    };

    const gotoIncompleteImaging = () => {
        history.push(PATH_IMAGING);
    };

    const onLabWorkCardClick = () => {
        if (isLabworkManual && labWorkStatus !== LabworkStatus.COMPLETED && labWorkStatus !== LabworkStatus.INPROGRESS) {
            //set lab work to incomplete (in-progress)
            setSubmitting(true);
        } else {
            labWorkTaskToIncompletesSubmissionSuccess();
        }
    };

    const onImagingCardClick = () => {
        gotoIncompleteImaging();
    };

    return (
        <>
            <Box minHeight={80} pt={0} pb={1} display="flex" className={styling.introSection}>
                <Grid container wrap="nowrap" alignItems="center" spacing={2}>
                    <Grid item xs zeroMinWidth>
                        <Typography data-cy="label_task_title" variant="h2" className={styling.TaskTitle}>
                            Your Tasks
                        </Typography>
                        <Typography data-cy="label_tasks_due_date" variant="caption" className={styling.fontWeight500}>
                            Due {formatDateMMMMDYYYY(taskDueDate)}
                        </Typography>
                    </Grid>
                    <Grid item zeroMinWidth>
                        {/* This one is similar to SurveyResponsePage answers, but not the same. */}
                        <Paper
                            elevation={0}
                            className={taskNotOverdue ? styling.timeUntilBox : styling.timeUntilBoxWarning}
                            component={Box}
                            display="flex"
                            alignItems="center"
                            flexGrow={0}
                            data-cy="label_days_left"
                        >
                            <Typography
                                variant="caption"
                                className={clsx(styling.fontWeight500, {
                                    [styling.overDueTextColor]: !taskNotOverdue,
                                })}
                            >
                                {daysLeftFromToday(taskDueDate)}
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
            <CardList data-cy="container_task_list">
                {isLabWorkTaskPresent && (
                    <CardItem
                        data-cy="button_blood_test"
                        Badge={labWorkStatus === LabworkStatus.COMPLETED ? image(DoneBadge, 'done badge') : image(BloodBadge, 'blood badge')}
                        title="Get a Blood Test"
                        subtitle={
                            labWorkStatus === LabworkStatus.COMPLETED ? 'Done' : labWorkStatus === LabworkStatus.INPROGRESS ? 'Incomplete' : 'Tap to begin'
                        }
                        onClick={() => onLabWorkCardClick()}
                        bgColor={labWorkStatus === LabworkStatus.COMPLETED && getDoneBackgroundColor(theme)}
                    />
                )}
                {isWellnessSurveyTaskPresent && (
                    <CardItem
                        data-cy="button_epic_26_survey"
                        Badge={wellnessSurveyTaskDone ? image(DoneBadge, 'done badge') : image(RecordBadge, 'record badge')}
                        title="Record your Symptoms"
                        subtitle={wellnessSurveyTaskDone ? 'Done' : 'Tap to begin'}
                        onClick={() => cardClickHandler(PATH_WELLNESS_SURVEY_HOME)}
                        bgColor={wellnessSurveyTaskDone && getDoneBackgroundColor(theme)}
                    />
                )}
                {isImagingTaskPresent && (
                    <CardItem
                        data-cy="button_imaging_test"
                        Badge={imagingTaskDone ? image(DoneBadge, 'done badge') : image(ImageBadge, 'imaging badge')}
                        title="Get an Imaging Test"
                        subtitle={imagingTaskDone ? 'Done' : 'Tap to begin'}
                        onClick={() => onImagingCardClick()}
                        bgColor={imagingTaskDone && getDoneBackgroundColor(theme)}
                    />
                )}
                {isFreeTextSurveyTaskPresent && (
                    <CardItem
                        Badge={freeTextSurveyTaskDone ? image(DoneBadge, 'done badge') : image(RecordBadge, 'record badge')}
                        title="Record your symptoms"
                        subtitle={freeTextSurveyTaskDone ? 'Done' : 'Tap to begin'}
                        onClick={() => {
                            cardClickHandler(PATH_FREE_TEXT_SURVEY_HOME);
                        }}
                        bgColor={freeTextSurveyTaskDone && getDoneBackgroundColor(theme)}
                        dataCy="button_record_your_symptoms_free_text"
                    />
                )}
            </CardList>
            <NextUp cardTitle={nextUpCardTitle} cardText={nextUpCardText} CardImage={nextUpCardImage} cardMediaBoxFlexStyle={true} />
            <YourJourneyComponent visits={allVisits} patientDiagnosisDate={patientDiagnosisDate} />
            <DataSubmissionHandler
                setSubmitting={setSubmitting}
                submitting={submitting}
                actionCreator={dispatchDataSubmissionResult => {
                    return labWorkTaskInProgressMarking(dispatchDataSubmissionResult, true);
                }}
                failureMsgTitle={labWorkInProgressSubmissionFailureTitle}
                failureMsgBody={labWorkInProgressSubmissionFailureBody}
                submissionSuccessHandler={labWorkTaskToIncompletesSubmissionSuccess}
            />
        </>
    );
};

const CompleteTaskBoard = withRouter(WaitingReviewTaskBoard);

export const ViewDoctorNote = () => {
    const classes = useStyles({})();
    const dispatch = useDispatch();
    const bigMobileScreen = useMediaQuery('(min-width:635px) and (max-width:830px)');

    const onCardClick = () => {
        const noteViewedAnalytics = createClientAnalytics(AuditEventAction.NOTE_VIEWED.category, AuditEventAction.NOTE_VIEWED.action);
        dispatch(sendClientAnalytics(noteViewedAnalytics));
        window.location = PATH_DOCTOR_NOTE;
    };

    return (
        <>
            <Typography
                data-cy="label_task_title"
                variant="h2"
                className={clsx(classes.viewDoctorNoteTitle, {
                    [classes.viewDoctorNoteTitleBigMobileScreen]: bigMobileScreen,
                })}
            >
                Your Tasks
            </Typography>
            <div className={classes.cardListBox}>
                <CardList>
                    <CardItem
                        Badge={DoctorNoteBadge}
                        title="View your Doctor's Note"
                        subtitle={'Tap to view'}
                        onClick={onCardClick}
                        datatestid="viewDoctorNoteCard"
                    />
                </CardList>
            </div>
        </>
    );
};

function NextUpCardSection({ currentVisitAssessment }) {
    const dispatch = useDispatch();
    const [openDialog, setOpenDialog] = useState(false);
    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    let cardTitle, cardText, cardImage, linkText, onClick, dialog;
    switch (currentVisitAssessment) {
        case VisitAssessments.PHONE_REQUIRED:
        case VisitAssessments.VIDEO_REQUIRED: {
            const handleConfirm = () => {
                dispatch(closeCurrentVisit(true));
                handleCloseDialog();
            };
            cardTitle = 'Call with your doctor';
            cardText =
                "Your doctor's office will get in touch with you about your upcoming call. If you have not heard back within three business days, please contact your doctor's office.";
            linkText = "I already completed the call with my doctor. What's next?";
            dialog = (
                <AlertModalYesNo
                    isDisplayed={openDialog}
                    alertModalTitle="Complete Your Follow-up"
                    alertModalBody="Confirm that you've completed the call with your doctor to receive your next routine follow-up date."
                    noButtonText="Cancel"
                    yesButtonText="Confirm"
                    onCloseSelected={handleCloseDialog}
                    onNoSelected={handleCloseDialog}
                    onYesSelected={handleConfirm}
                />
            );
            onClick = handleClickOpenDialog;
            cardImage = CallDoctor;
            break;
        }
        case VisitAssessments.IN_CLINIC_REQUIRED: {
            const handleConfirm = () => {
                dispatch(closeCurrentVisit(true));
                handleCloseDialog();
            };
            cardTitle = 'In-Clinic Visit Required';
            cardText =
                "Your doctor's office will get in touch with you about your upcoming visit. If you have not heard back within three business days, please contact your doctor's office.";
            linkText = "I already completed the visit with my doctor. What's next?";
            dialog = (
                <AlertModalYesNo
                    isDisplayed={openDialog}
                    alertModalTitle="Complete Your Follow-up"
                    alertModalBody="Confirm that you've completed the visit with your doctor to receive your next routine follow-up date."
                    noButtonText="Cancel"
                    yesButtonText="Confirm"
                    onCloseSelected={handleCloseDialog}
                    onNoSelected={handleCloseDialog}
                    onYesSelected={handleConfirm}
                />
            );
            onClick = handleClickOpenDialog;
            cardImage = CallDoctor;
            break;
        }
        case VisitAssessments.NO_CONCERNS:
        case VisitAssessments.OFF_PROTOCOL:
        case VisitAssessments.IN_PERSON:
        default:
            return null;
    }
    return (
        <>
            <NextUp wrapToImage={true} cardTitle={cardTitle} cardText={cardText} CardImage={cardImage} linkText={linkText} onClick={onClick} />
            {dialog}
        </>
    );
}

const mapStateToProps = state => {
    return {
        accountState: state?.login?.session?.extraFields?.accountState ?? '',
        isLoadingVisit: state?.dataLoading?.visit?.loading !== LoadingStatus.ENDED,
        visitLoadingResult: state?.dataLoading?.visit?.loadingResult,
        allVisits: state?.allVisits?.visits,
        isLoadingAllVisits: state?.dataLoading?.allVisits?.loading !== LoadingStatus.ENDED,
        allVisitsLoadingResult: state?.dataLoading?.allVisits?.loadingResult,
        patientDiagnosisDate: state?.login?.session?.extraFields?.diagnosisDate ?? '',
    };
};

const mapDispatchToProps = dispatch => {
    const fetchAllVisits = () => {
        dispatch(retrieveAllVisits());
    };
    const updateUnreadMessageCount = unreadMessageCount => {
        dispatch(updateUnreadMessages(unreadMessageCount));
    };
    const setMaxUnreadMessageCount = maximumUnreadMessageCount => {
        dispatch(setMaximumUnreadMessageCount(maximumUnreadMessageCount));
    };
    return {
        fetchAllVisits,
        updateUnreadMessageCount,
        setMaxUnreadMessageCount,
    };
};

const TaskHome = connect(mapStateToProps, mapDispatchToProps)(TaskHomeContent);

export default function GuardedTaskHome({ isTutorial }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(styleBreakMobile(theme));
    const [launchOnboardingTutorial, setLaunchOnboardingTutorial] = useState(isTutorial ? isTutorial : false);
    const tutorialPageSubtitleText = 'Welcome to your Watchman Homepage';
    const tutorialPageBodyText =
        "This will be your go to page when using Watchman, here you'll have an overview of all thats required of you and your clinicians feedback all in one page, pretty sweet!";
    const ONBOARDING_TUTORIAL_SEGMENTS = 7;

    if (isWatchman && launchOnboardingTutorial) {
        return (
            <TutorialWelcomePage
                subtitleText={tutorialPageSubtitleText}
                bodyText={tutorialPageBodyText}
                setLaunchTutorial={setLaunchOnboardingTutorial}
                noOfPages={ONBOARDING_TUTORIAL_SEGMENTS}
                isMobile={isMobile}
                type={'Onboarding'}
            />
        );
    } else
        return (
            <RequiresLogin>
                <CurrentVisitUser>
                    <TaskHome />
                </CurrentVisitUser>
            </RequiresLogin>
        );
}

export function* setLabWorkTaskToIncompleteSaga(action) {
    try {
        yield call(markLabWorkTaskAsInProgress);

        /* dispatch result of data submission */
        if (action.dispatchDataSubmissionResult) {
            yield put(action.dispatchDataSubmissionResult(true));
        }

        if (action.refreshVisit) {
            yield put(retrieveCurrentVisit());
        }
    } catch (error) {
        /* dispatch result of data submission */
        if (action.dispatchDataSubmissionResult) {
            yield put(action.dispatchDataSubmissionResult(false));
        }
        console.dir(error);
    }
}

export function* watchSetLabWorkTaskToIncomplete() {
    yield takeLatest(actions.MARK_LAB_WORK_TASK_AS_IN_PROGRESS, setLabWorkTaskToIncompleteSaga);
}
